import React, { useRef, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { FormControl, InputLabel, Select, MenuItem, Checkbox, ListItemText } from '@mui/material';
import "../css/WbtemplateDetails.css";
import CustomDateRangePicker from "../components/CustomDatePicker";
import { useUIContext } from "../context";
import Search from "../Assets/images/search.png";
import information from "../Assets/images/information-button.png";

import { ClipLoader } from 'react-spinners';
import { apiCall } from "../services/authServieces";
import { Chart, LineController, CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend, BarController, BarElement } from 'chart.js';


Chart.register(LineController, CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend, BarController, BarElement);

function WbtemplateDetails() {
    const [selectedMetrics, setSelectedMetrics] = useState(['Whatsapp Sent', 'Whatsapp Delivered', 'Whatsapp Read',]);
    const chartRef = useRef(null);
    const buttonClicksChartRef = useRef(null);
    const [activeTab, setActiveTab] = useState('table');
    const [chartInstance, setChartInstance] = useState(null);

    const [buttonClicksChartInstance, setButtonClicksChartInstance] = useState(null);
    const [templateData, setTemplateData] = useState({
        id: '',
        title: '',
        message: '',
        buttons: [],
        stats: {
            amountSpent: "₹0.00",
            costPerMessage: "₹0.00",
            costPerClick: "₹0.00",
            messagesSent: "0",
            messagesDelivered: "0",
            messagesRead: "0 (0%)",
            // replies: "0",
            buttonClicks: []
        },
        dailyStats: []

    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [PrecentageSend, setPrecentageSend] = useState(0);
    const [DeliveredMessage, setDeliveredMessage] = useState(0);
    const [ReadPracentage, setReadPracentage] = useState(0);
    const [ClickType, setClickType] = useState("total_clicks")


    const { dateRanges, setDateRanges } = useUIContext(); // setDateRanges को भी प्राप्त करें




    const handleMetricsChange = (event) => {
        setSelectedMetrics(event.target.value);
    };


    // पेज लोड होने पर एक बार चलेगा
    useEffect(() => {
        // आज की तारीख
        const today = new Date();

        // एक सप्ताह पहले की तारीख
        const oneWeekAgo = new Date();
        oneWeekAgo.setDate(today.getDate() - 7);

        // dateRanges को अपडेट करें
        setDateRanges(prevRanges => ({
            ...prevRanges,
            mis: [oneWeekAgo, today]
        }));
    }, []); // खाली dependency array का मतलब है यह केवल एक बार चलेगा

    const dates = dateRanges.mis.map(date => {
        if (!date) return undefined;

        const localDate = new Date(date);
        const year = localDate.getFullYear();
        const month = String(localDate.getMonth() + 1).padStart(2, "0");
        const day = String(localDate.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
    });
    const [startDate, endDate] = dates;

    // Get template ID and name from URL params
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const tempid = params.get('tempid');
    const tempname = params.get('tempname');

    // Format date for display
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    const updateDate = new Date();
    const formattedUpdateDate = formatDate(updateDate);

    // Fetch template data from API
    const getTemplateData = async (tempId, tempName, startDate, endDate, ClickData) => {
        setLoading(true);
        try {
            let payload = {
                template_id: tempId,
                tempate_name: tempName,
                startDate: startDate,
                endDate: endDate,
                click_type: ClickData
            };

            
            const response = await apiCall({
                endpoint: 'api/dealers/template_data',
                method: 'POST',
                payload: payload
            });

            if (response.success) {
                // Extract button data from template
                const buttons = [];
                if (response.temp_result.UrlBtnText1) {
                    buttons.push({ label: response.temp_result.UrlBtnText1, icon: "🔗", type: "video" });
                }
                if (response.temp_result.UrlBtnText2) {
                    buttons.push({ label: response.temp_result.UrlBtnText2, icon: "🔗", type: "website" });
                }
                if (response.temp_result.phone_text1) {
                    buttons.push({ label: response.temp_result.phone_text1, icon: "📞", type: "Call US" });
                }



                // Add quick reply buttons if they exist
                const quickReplyFields = [
                    'quickReply1', 'quickReply2', 'quickReply3', 'quickReply4', 'quickReply5',
                    'quickReply6', 'quickReply7', 'quickReply8', 'quickReply9', 'quickReply10'
                ];

                quickReplyFields.forEach(field => {
                    if (response.temp_result[field]) {
                        buttons.push({
                            label: response.temp_result[field],
                            icon: "📝",
                            type: "quickReply"
                        });
                    }
                });




                setPrecentageSend(response.finalsend_pracentage || 0)
                setDeliveredMessage(response.finalsend_delivered || 0)

                setReadPracentage(response.finalsend_Read || 0)
                // setClickType(response.click_type)
                setTemplateData({
                    id: tempId,
                    title: response?.temp_result?.f_text || tempName,
                    message: response?.temp_result?.message || "",
                    buttons: buttons,
                    stats: response.template_stats || templateData.stats,
                    dailyStats: response.daily_stats || []

                });

            } else {
                setError("Failed to fetch template data");
            }
        } catch (error) {
            console.error('Error fetching template data:', error);
            setError("Error fetching template data. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    // Initial data load
    useEffect(() => {
        if (tempid && tempname && startDate && endDate) {
            getTemplateData(tempid, tempname, startDate, endDate, ClickType);
        }
    }, [startDate, endDate]);

    // Update charts when template data changes

    // Add selectedMetrics to the dependency array of your chart useEffect
    useEffect(() => {
        // Destroy existing charts to prevent memory leaks
        if (chartInstance) {
            chartInstance.destroy();
        }

        if (buttonClicksChartInstance) {
            buttonClicksChartInstance.destroy();
        }

        // Create performance chart
        if (chartRef.current && templateData.dailyStats && templateData.dailyStats.length > 0) {
            const dailyStats = templateData.dailyStats;

            // Define all datasets but only include the selected ones
            const allDatasets = [
                {
                    label: 'Whatsapp sent',
                    data: dailyStats.map(day => day.messages_sent),
                    borderColor: '#ff6666',
                    pointBackgroundColor: '#ff6666',
                    pointBorderColor: '#ff6666',
                    pointBorderWidth: 1,
                    pointRadius: 3,
                    pointStyle: 'rect',
                    tension: 0,
                    hidden: !selectedMetrics.includes('Whatsapp Sent')
                },
                {
                    label: 'Whatsapp delivered',
                    data: dailyStats.map(day => day.messages_delivered),
                    borderColor: '#8855aa',
                    pointBackgroundColor: '#8855aa',
                    pointBorderColor: '#8855aa',
                    pointBorderWidth: 1,
                    pointRadius: 3,
                    pointStyle: 'rect',
                    tension: 0,
                    hidden: !selectedMetrics.includes('Whatsapp Delivered')
                },
                {
                    label: 'Whatsapp read',
                    data: dailyStats.map(day => day.messages_read),
                    borderColor: '#22aa99',
                    pointBackgroundColor: '#22aa99',
                    pointBorderColor: '#22aa99',
                    pointBorderWidth: 1,
                    pointRadius: 3,
                    pointStyle: 'rect',
                    tension: 0,
                    hidden: !selectedMetrics.includes('Whatsapp Read')
                },

                // {
                //     label: 'Replies',
                //     data: Array(dailyStats.length).fill(templateData.stats.replies), // Now filling replies for each day
                //     borderColor: '#343434',
                //     pointBackgroundColor: '#343434',
                //     pointBorderColor: '#343434',
                //     pointBorderWidth: 1,
                //     pointRadius: 3,
                //     pointStyle: 'rect',
                //     tension: 0,
                //     hidden: !selectedMetrics.includes('Replies')
                // }
            ];

            // Filter datasets to only include selected metrics
            const visibleDatasets = allDatasets.filter(dataset =>
                selectedMetrics.includes(dataset.label.replace(' ', ' '))
            );

            const newChart = new Chart(chartRef.current, {
                type: 'line',
                data: {
                    labels: dailyStats.map(day => day.date),
                    datasets: allDatasets // Using all datasets, with hidden property controlling visibility
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            display: false
                        },
                        tooltip: {
                            mode: 'index',
                            intersect: false
                        }
                    },
                    scales: {
                        y: {
                            beginAtZero: true,
                            grid: {
                                color: '#f0f0f0'
                            }
                        },
                        x: {
                            grid: {
                                display: false
                            }
                        }
                    }
                }
            });

            setChartInstance(newChart);
        }

        if (buttonClicksChartRef.current && activeTab === 'graph' && templateData.stats.buttonClicks.length > 0) {
            const buttonClicks = templateData.stats.buttonClicks;

            const clicksData = {
                labels: buttonClicks.map(item => item.label),
                datasets: [
                    {
                        label: 'Total Clicks',
                        data: buttonClicks.map(item => {
                            const numStr = item.clicks.replace('K', '000');
                            return parseInt(numStr.replace(/[^\d.-]/g, ''));
                        }),
                        borderColor: '#0099ff',
                        backgroundColor: 'transparent',
                        pointBackgroundColor: '#0099ff',
                        pointBorderColor: '#0099ff',
                        pointBorderWidth: 1,
                        pointRadius: 3,
                        pointStyle: 'rect',
                        tension: 0,
                    }
                ]
            };

            const newButtonClicksChart = new Chart(buttonClicksChartRef.current, {
                type: 'line',
                data: clicksData,
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            display: false
                        },
                        tooltip: {
                            callbacks: {
                                label: function (context) {
                                    const clickIndex = context.dataIndex;
                                    const buttonClick = buttonClicks[clickIndex];
                                    return [
                                        `Total clicks: ${buttonClick.clicks}`,
                                        `Click rate: ${buttonClick.rate}`,
                                        `Increase: ${buttonClick.increase}`
                                    ];
                                }
                            }
                        }
                    },
                    scales: {
                        y: {
                            beginAtZero: true,
                            grid: {
                                color: '#f0f0f0'
                            }
                        },
                        x: {
                            grid: {
                                display: false
                            }
                        }
                    }
                }
            });

            setButtonClicksChartInstance(newButtonClicksChart);
        }
    }, [templateData, activeTab, selectedMetrics]); // Add selectedMetrics to dependency array
    // Handle search button click
    const handleSearch = async () => {
        await getTemplateData(tempid, tempname, startDate, endDate, ClickType);
    };



    const metricMapping = {
        'Whatsapp Sent': {
            title: 'Whatsapp sent',
            value: templateData.stats.messagesSent,
            percentage: isNaN(PrecentageSend) ? '0%' : `${PrecentageSend}%`,
            showArrow: true,
            tooltip: 'The number of Whatsapp that your business sent to customers. <br/> Performance metrics are reported within 7 days after a message is sent.'
        },
        'Whatsapp Delivered': {
            title: 'Whatsapp delivered',
            value: templateData.stats.messagesDelivered,
            percentage: isNaN(DeliveredMessage) ? '0%' : `${DeliveredMessage}%`,
            showArrow: true,
            tooltip: 'The number of Whatsapp that your business sent to customers that were delivered. <br /> Performance metrics are reported within 7 days after a message is sent. <br /><br /> Some Whatsapp may not be delivered, such as when a customers device is out of service. This number does not include Whatsapp sent to or from the European Union, the United Kingdom or Japan. <br/><br /> In some cases, this metric may be estimated and may differ from whats shown on your invoice due to small variations in data processing.'
        },
        'Whatsapp Read': {
            title: 'Whatsapp read',
            value: templateData.stats.messagesRead,
            percentage: isNaN(ReadPracentage) ? '0%' : `${ReadPracentage}%`,
            showArrow: true,
            tooltip: '<h6>Whatsapp Read</h6>The number of Whatsapp your business sent to customers that were delivered and read. <br/><br/> Performance metrics are reported within 7 days after a message is sent. </br><br/> <h6>Message read rate</h6> The percentage of Whatsapp read. Message read rate is the number of Whatsapp read divided by the number of Whatsapp delivered.'
        },
        // 'Replies': {
        //     title: 'Replies',
        //     value: templateData.stats.replies,
        //     percentage: null,
        //     showArrow: false,
        //     tooltip: '<h6>Whatsapp replied</h6>The number of accounts that replied to your template message within 7 days of receiving the message. <br/><br/> This number does not include Whatsapp sent to or from the European Union, the United Kingdom or Japan. <br/><br/> <h6>Reply rate</h6>The reply rate for your message template is the percentage of Whatsapp that received a response, calculated by dividing the number of Whatsapp replied to by the number of Whatsapp delivered within 7 days after sending. This number does not include Whatsapp sent to or from the European Union, the United Kingdom or Japan.'
        // }
    };


    const handleSelectChange = (e) => {
        const selectedValue = e.target.value;
        console.log('selectedValue: ', selectedValue);
        setClickType(selectedValue);  // Update state to match selected value
        getTemplateData(tempid, tempname, startDate, endDate, selectedValue);  // Pass updated value to API
    };








    return (
        <>
            <h4 className="Head_title2">
                <div className='header_title_div'>
                    <div className='left_header_title'>
                        <h4>{tempname}</h4>
                        <p>Created on {formattedUpdateDate}</p>
                    </div>
                    <div className="DateRangeContain DateRangeContain_new">
                        <CustomDateRangePicker rangeKey="mis" />
                        <button type="button" className="SearchDateRange" onClick={handleSearch}>
                            <img src={Search} alt="Search" />
                        </button>
                    </div>
                </div>
            </h4>

            {loading ? (
                <>
                    <div className="spinnerOverlay1">
                        <ClipLoader size={50} />
                    </div>
                    <div className="loading-container">Loading template data...</div>
                </>
            ) : error ? (
                <div className="error-container">{error}</div>
            ) : (
                <div className="WbtemplateDetails-container">
                    <div className="left-side-container">
                        <div className="WbtemplateDetails-card template-card active-template">
                            <h3 className="WbtemplateDetails-cardTitle">Template preview</h3>
                            {/* <h4 className="template-title">{templateData.title}</h4> */}
                            <div className="WbtemplateDetails-templatePreview">
                                <div className="WbtemplateDetails-message">
                                    <p>{templateData.message}</p>
                                    <span className="WbtemplateDetails-timestamp">09:48</span>
                                </div>
                                {templateData.buttons.map((button, idx) => (
                                    <button key={idx} className={`WbtemplateDetails-button WbtemplateDetails-${button.type}Button`}>
                                        <span className="WbtemplateDetails-buttonIcon">{button.icon}</span> {button.label}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="right-side-container">
                        <div className="WbtemplateDetails-statsRow">
                            <div className="WbtemplateDetails-card">
                                <h3 className="WbtemplateDetails-cardTitle">Amount spent
                                    <span className="WbtemplateDetails-infoIcon">
                                        <img src={information} alt='info icon' />
                                        <span className="WbtemplateDetails-infoTooltip">
                                            The approximate total amount of money that you've spent on your whatsApp template. The cost of a conversation is only attributed to the first template sent in a 24-hour conversation window.
                                        </span>
                                    </span>
                                </h3>
                                <div className="WbtemplateDetails-statValue">{templateData.stats.amountSpent}</div>
                            </div>
                            <div className="WbtemplateDetails-card">
                                <h3 className="WbtemplateDetails-cardTitle">Cost per WhatsApp delivered
                                    <span className="WbtemplateDetails-infoIcon">
                                        <img src={information} alt='info icon' />
                                        <span className="WbtemplateDetails-infoTooltip">
                                            Cost per WhatsApp delivered is calculated as the amount spent divided by the number of WhatsApp delivered up to 7 days after a message is sent.
                                        </span>
                                    </span>
                                </h3>
                                <div className="WbtemplateDetails-statValue">{templateData.stats.costPerMessage}</div>
                            </div>
                            {/* <div className="WbtemplateDetails-card">
                                <h3 className="WbtemplateDetails-cardTitle">Cost per website button click
                                    <span className="WbtemplateDetails-infoIcon">
                                        <img src={information} alt='info icon' />
                                        <span className="WbtemplateDetails-infoTooltip">
                                            Cost per website button click is calculated as the amount spent divided by the number of button clicks up to 7 days after a message is sent.
                                        </span>
                                    </span>
                                </h3>
                                <div className="WbtemplateDetails-statValue">{templateData.stats.costPerClick}</div>
                            </div> */}
                        </div>

                        <div className="WbtemplateDetails-card WbtemplateDetails-performanceCard">
                            <div className="WbtemplateDetails-buttonClicksHeader">
                                <h3 className="WbtemplateDetails-cardTitle">Performance
                                    <span className="WbtemplateDetails-infoIcon">
                                        <img src={information} alt='info icon' />
                                        <span className="WbtemplateDetails-infoTooltip">
                                            Whatsapp delivery and reads are only reported up to 7 days after a message is sent.
                                        </span>
                                    </span>
                                </h3>
                            </div>

                            <div className="WbtemplateDetails-performanceStats">
                                {selectedMetrics.map(metric => (
                                    <div className="WbtemplateDetails-statBlock" key={metric}>
                                        <h4 className="WbtemplateDetails-statTitle">
                                            {metricMapping[metric].title}
                                            <span className="WbtemplateDetails-infoIcon">
                                                <img src={information} alt="info icon" />
                                                <span
                                                    className="WbtemplateDetails-infoTooltip"
                                                    dangerouslySetInnerHTML={{ __html: metricMapping[metric].tooltip }}
                                                />
                                            </span>
                                        </h4>
                                        <div className="WbtemplateDetails-statValue WbtemplateDetails-smallerFont">
                                            {metricMapping[metric].value}
                                            {metricMapping[metric].showArrow && (
                                                <span className="WbtemplateDetails-percentIncrease">
                                                    <span className="WbtemplateDetails-arrowUp">↑</span> {metricMapping[metric].percentage}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <div className="WbtemplateDetails-chartContainer">
                                <div className="WbtemplateDetails-chartHeader">
                                    <div className="WbtemplateDetails-chartFilter">
                                        <FormControl fullWidth>
                                            <Select
                                                labelId="metrics-select-label"
                                                multiple
                                                value={selectedMetrics}
                                                onChange={handleMetricsChange}
                                                renderValue={(selected) => selected.join(', ')}
                                                className="WbtemplateDetails-chartSelect"
                                            >
                                                {['Whatsapp Sent', 'Whatsapp Delivered', 'Whatsapp Read'].map((metric) => (
                                                    <MenuItem key={metric} value={metric}>
                                                        <Checkbox checked={selectedMetrics.includes(metric)} />
                                                        <ListItemText primary={metric} />
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>
                                </div>
                                <div className="WbtemplateDetails-chart">
                                    <canvas ref={chartRef} height="200"></canvas>
                                </div>
                                <div className="WbtemplateDetails-chartLegend">
                                    <div className="WbtemplateDetails-legendItem">
                                        <span className="WbtemplateDetails-legendColor WbtemplateDetails-legendSent"></span>
                                        <span>Whatsapp Sent
                                        </span>
                                    </div>
                                    <div className="WbtemplateDetails-legendItem">
                                        <span className="WbtemplateDetails-legendColor WbtemplateDetails-legendDelivered"></span>
                                        <span>Whatsapp Delivered</span>
                                    </div>
                                    <div className="WbtemplateDetails-legendItem">
                                        <span className="WbtemplateDetails-legendColor WbtemplateDetails-legendRead"></span>
                                        <span>Whatsapp Read</span>
                                    </div>
                                    {/* <div className="WbtemplateDetails-legendItem">
                                        <span className="WbtemplateDetails-legendColor WbtemplateDetails-legendReplies"></span>
                                        <span>Replies</span>
                                    </div> */}
                                </div>
                            </div>
                        </div>
{/* 
                        <div className="WbtemplateDetails-card">
                            <div className="WbtemplateDetails-buttonClicksHeader">
                                <h3 className="WbtemplateDetails-cardTitle">Button clicks
                                    <span className="WbtemplateDetails-infoIcon">
                                        <img src={information} alt='info icon' />
                                        <span className="WbtemplateDetails-infoTooltip">
                                            Button clicks are reported up to 7 days after a message is sent.
                                        </span>
                                    </span>
                                </h3>
                                <div className="WbtemplateDetails-buttonClicksControls">
                                    <div className="WbtemplateDetails-selectContainer">
                                        <select className="WbtemplateDetails-select" value={ClickType} onChange={handleSelectChange}>
                                            <option value="total_clicks">Total Clicks</option>
                                            <option value="unique_click">Unique Click</option>
                                        </select>


                                    </div>
                                    <div className="WbtemplateDetails-viewToggle">
                                        <button
                                            className={`WbtemplateDetails-toggleButton ${activeTab === 'table' ? 'WbtemplateDetails-active' : ''}`}
                                            onClick={() => setActiveTab('table')}
                                        >
                                            Table
                                        </button>
                                        <button
                                            className={`WbtemplateDetails-toggleButton ${activeTab === 'graph' ? 'WbtemplateDetails-active' : ''}`}
                                            onClick={() => setActiveTab('graph')}
                                        >
                                            Graph
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {activeTab === 'table' ? (
                                <div className="WbtemplateDetails-buttonClicksTable">
                                    <table className="WbtemplateDetails-table">
                                        <thead>
                                            <tr>
                                                <th>Label <span className="WbtemplateDetails-sortIcon">↕</span></th>
                                                <th>Type <span className="WbtemplateDetails-sortIcon">↕</span></th>
                                                <th>Total clicks <span className="WbtemplateDetails-sortIcon">↓</span></th>
                                                <th>Clicks vs previous <span className="WbtemplateDetails-sortIcon">↕</span></th>
                                                <th>Click rate <span className="WbtemplateDetails-sortIcon">↕</span></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {templateData.stats.buttonClicks.length > 0 ? (
                                                templateData.stats.buttonClicks.map((button, idx) => (
                                                    <tr key={idx}>
                                                        <td>{button.label}</td>
                                                        <td>{button.type}</td>
                                                        <td>{button.clicks}</td>
                                                        <td>
                                                            <span className="WbtemplateDetails-percentIncrease">
                                                                <span className="WbtemplateDetails-arrowUp">↑</span> {button.increase}
                                                            </span>
                                                        </td>
                                                        <td>{button.rate}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="5" className="no-data">No button click data available</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                <div className="WbtemplateDetails-buttonClicksGraph">
                                    <canvas ref={buttonClicksChartRef} height="200"></canvas>
                                </div>
                            )}
                        </div> */}
                    </div>
                </div>
            )}
        </>
    );
}

export default WbtemplateDetails;